import Support from "@material-symbols/svg-500/rounded/question_exchange.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const SupportIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Support });
	return <Icon />;
};

export default memo(SupportIcon);
